import React from 'react'
import {SiCodechef, SiLeetcode} from 'react-icons/si'
import {FaHackerrank} from 'react-icons/fa'
import 'aos/dist/aos.css'

export default function Skills() {
  return (
    <div>
        <p className='flex justify-center pt-10 sm:pt-60 text-2xl sm:text-4xl text-slate-300 font-cust'>My Coding Profiles</p>

        <div className='md:grid md:grid-cols-3 pt-3 flex justify-center flex-wrap sm:pt-20'>

            
            <div data-aos="slide-down" className='flex justify-center my-2 sm:my-0 ml-5 right-0 left-0 md:mx-auto flex-col
             bg-gradient-to-b from-amber-100 to-orange-900 text-6xl sm:text-8xl w-20 h-20 sm:w-40 sm:h-40 px-2 sm:pt-1 sm:pl-8 shadow-black shadow-xl hover:shadow-orange-300 rounded-2xl text-black'>
            <a rel="noreferrer" href='https://codechef.com/users/Anurag231' target='_blank'>
            <SiCodechef />
            </a>
            </div>
            

            <a rel='noreferrer' href='https://leetcode.com/_anuraag_' target='_blank'>
            <div className='flex justify-center my-2 sm:my-0 ml-5 right-0 left-0  md:mx-auto
            flex-col bg-gradient-to-b from-amber-400 to-amber-900 text-6xl sm:text-8xl w-20 h-20 sm:w-40 sm:h-40 px-2 sm:pt-1 sm:pl-8 shadow-black shadow-xl hover:shadow-blue-400 rounded-full hover:text-yellow-900 text-white'>
            <SiLeetcode className='hover:animate-ping'/>
            </div> 
            </a>

            <a data-aos="slide-up" rel='noreferrer' href='https://hackerrank.com/A_1901640100066' target='_blank'>
            <div  className='flex justify-center my-2 sm:my-0 ml-5 right-0 left-0 md:mx-auto flex-col bg-gradient-to-b from-green-500 to-green-900 text-6xl sm:text-8xl w-20 h-20 sm:w-40 sm:h-40 px-2 sm:pt-1 sm:pl-8 shadow-black shadow-xl hover:shadow-yellow-400 rounded-2xl text-green-900 hover:text-black'>
            <FaHackerrank className='hover:animate-pulse'/>
            </div> 
            </a>    

        </div>

    </div>
  )
}
